import { render, staticRenderFns } from "./CargaMuestras.vue?vue&type=template&id=5bb2549a&"
import script from "./CargaMuestras.vue?vue&type=script&lang=js&"
export * from "./CargaMuestras.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports